<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        11.17
        <br />2016
      </span>
      <span class="tiel">中国美菜 世界互联网大会--刘传军：美菜发布“冷美人计划”</span>
    </div>

    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/b4.jpg" width="640" />
      </p>
      <div class="tet-js">
        今天上午（11月17日），在乌镇召开的第三届世界互联网大会现场，不少嘉宾被一个特别的二维码吸引住了。通过扫描二维码，现场嘉宾可以很直观的追溯到这个名叫“马铃儿”的土豆订单产地、菜农信息等。这就是此次互联网大会的“互联网+物流”分论坛上，美菜网，带来了一个惊喜：为非标农产品提供监测二维码，初步探索，逐步实现农产品的可追溯系统。
        <br />
        <br />这家仅成立两年半的农产品B2B公司，第二次登上互联网大会的舞台。创始人、CEO刘传军在“互联网+物流”论坛上，作出《农业电商+高效冷链物流的变革之道》的主题演讲。并发布了新的冷链物流战略：“冷美人计划”。
      </div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>“冷美人计划” 降低农产品损耗
      </div>
      <div class="tet-js">
        刘传军的主题演讲中，阐述了由于我国农产品冷链设施不完善导致农产品损耗严重 ，并直言如何降低农产品损耗，提高时效性以保障农产品的新鲜度，是整个农产品电商行业的痛点，也是美菜一直在探索实践的命题。
        <br />
        <br />为了解决这一难题，美菜采用众包模式，整合社会车辆，并有严格的绩效管理。每天清晨，会派出5000辆车完成生鲜配送。在仓储方面，美菜目前已在北京、上海、广州、深圳、杭州、武汉、成都、西安等30个城市建立了近30个仓储中心。从田间地头到消费地区周边，设立有保鲜，冷库等多种库房类型。逐步实现冷链保证，搭建起仓储与物流的无缝温控体系。
        <br />
        <br />除此之外，借助世界互联网大会，美菜发布了“冷美人计划”，此计划的核心是：美菜网将计划购置3000~5000辆冷链运输车投入配送体系。由此看来，美菜决心在物流方面下足功夫，通过这一计划，逐步探索并尝试突破行业瓶颈，降低农产品损耗，将田间和餐厅以快速冷链的方式联系起来。
      </div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>冷链物流需要规模化做支撑
      </div>
      <div class="tet-js">
        “要实现农业现代化，解决流通环节是很好的切入点。而打通流通环节的根本是实现农产品的规模化，且量大稳定。”刘传军表示，只有以流通串联生产者和渠道，才能真正降低损耗，提高效率。
        <br />
        <br />自建的高效冷链物流是中间基础，一端链接田间地头的农民，一端链接市场和城市消费。农民可以去种植、生产足够量大且安全的农产品，通过美菜冷链物流和仓储体系一站式送达城市餐厅。
        <br />
        <br />由此来看，美菜打破了传统模式，通过给农民提供服务的方式来建立稳定的基地合作。不断积累形成量大且稳定的农产品规模，保证好货源的同时，产生价格优势，借此来打通流通环节。实现规模化是稳定物流的基础，也是“互联网+物流”的前提。
      </div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>“大数据平台”成冷链物流保障
      </div>
      <div class="tet-js">
        美菜网通过开发“大数据平台”，首先尝试非标农产品的监测系统，让消费者追索到农产品的全过程。
        <br />
        <br />其次，通过研发的TMS系统，运用大数据，计算出每天每车辆货品承载量，并合理规划配送路线。并通过车辆GPS定位系统等物流配送管理平台，做到冷链物流科学管理，车辆实时控制。大大降低高效冷链物流成本，避免更多重复性的流通。
        <br />
        <br />美菜下一步还将和更多的农户签署订单。通过“大数据平台”将市场需求形成数据反馈给农民农产品的产量，这样既避免了货不对市，又通过解决销路问题给予了农民很好的保障。
        <br />
        <br />从“帮人卖菜”到“冷链物流一站式送达餐厅”，从“替餐馆买菜”到“服务农民生产”。我们相信，美菜一直在聚集一点一滴的力量，用创新驱动来改变中国农业，中国农村。中国美菜，为“互联网+农业”助力！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
